import { render, staticRenderFns } from "./CowsUnitPurchaseRegistration.vue?vue&type=template&id=5589268c&scoped=true&"
import script from "./CowsUnitPurchaseRegistration.vue?vue&type=script&lang=js&"
export * from "./CowsUnitPurchaseRegistration.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "5589268c",
  null
  
)

export default component.exports